import { css } from 'emotion';
import { clamp } from 'ramda';

import { getVideoElement } from '@ezugi/bootstrap/src/util/getVideoElement';
import { SICBO_ULTIMATE_ID, GAME_ID_FROM_URL } from '@ezugi/constants';
import { DeviceInfo } from '@ezugi/utils';

export const betToolbarClassName = css`
  @media (orientation: landscape) {
    padding-bottom: 34px;
  }

  @media all and (orientation: portrait) {
    z-index: 1;
  }
`;

/**
 * Adjust the gradient pseudo-elements to match the blackbars of the video
 * @returns {void}
 */
export function gameVideoHandler() {
  const videoElement = getVideoElement();

  if (!videoElement || !DeviceInfo.isHandheld) return;

  const blackbarWidth = clamp(0, 100, videoElement.offsetLeft);

  document.body.style.setProperty('--blackbar-width', `${blackbarWidth}px`);
}

export const isUltimateSicBo = GAME_ID_FROM_URL === SICBO_ULTIMATE_ID;
